module.exports = __webpack_public_path__ + "static/img/photo-02-big.31ec317.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo-02-big.jpg
// module id = i6Dw
// module chunks = 1